import { render } from "./Carousel2.vue?vue&type=template&id=19199813"
import script from "./Carousel2.vue?vue&type=script&lang=js"
export * from "./Carousel2.vue?vue&type=script&lang=js"

import "./Carousel2.vue?vue&type=style&index=0&id=19199813&lang=scss"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__